// ---- Recently Viewed Products ----

// 🔹 Thay đổi số này mỗi lần update code để auto reset cho tất cả user
const RECENTLY_VIEWED_VERSION = "4";

// Kiểm tra version, nếu khác thì xóa dữ liệu cũ
if (localStorage.getItem("rv_version") !== RECENTLY_VIEWED_VERSION) {
  localStorage.removeItem("viewed_products");
  localStorage.setItem("rv_version", RECENTLY_VIEWED_VERSION);
}

document.addEventListener("DOMContentLoaded", function () {
  console.log("Recently Viewed loaded!");

  if (!window.currentProduct || !window.currentProduct.handle) return;

  let viewedProducts = JSON.parse(localStorage.getItem("viewed_products")) || [];

  // Xóa sản phẩm trùng lặp
  viewedProducts = viewedProducts.filter(
    (p) => p.handle !== window.currentProduct.handle
  );

  // Thêm sản phẩm mới vào đầu danh sách
  viewedProducts.unshift(window.currentProduct);

  // Giữ đúng 10 sản phẩm
  viewedProducts = viewedProducts.slice(0, 10);

  // Lưu vào localStorage
  localStorage.setItem("viewed_products", JSON.stringify(viewedProducts));

  // Render danh sách
  renderRecentlyViewed(viewedProducts);
});

function renderRecentlyViewed(viewedProducts) {
  const section = document.getElementById("recently-viewed-section");
  const container = document.getElementById("recently-viewed-list");

  if (!viewedProducts || viewedProducts.length === 0) {
    section.style.display = "none";
    return;
  }

 section.style.display = "block";
    container.innerHTML = viewedProducts
    .map(
        (product) => `
        <li class="recently-viewed-item">
            <a href="${product.url}">
            <div class="image-container ${
                product.image2 ? "has-hover" : "zoom-only"
            }">
                <img 
                src="${product.image}" 
                class="recently-viewed-img primary-img"
                alt="${product.title}"
                loading="lazy"
                >
                ${
                product.image2
                    ? `<img 
                        src="${product.image2}" 
                        class="recently-viewed-img secondary-img"
                        alt="${product.title}"
                        loading="lazy"
                    >`
                    : ""
                }
            </div>
            <div class="product-info">
                <p class="vendor_text_1">${product.vendor}</p>
                <p>${product.title}</p>
                <p>${product.price.replace(/\.00$/, "")}</p>
            </div>
            </a>
        </li>
        `
    )
    .join("");

  // ⚡ Tự động cuộn về đầu
  container.scrollLeft = 0;
}
